<template>
    <ul class="nav nav-tabs conversions-tabs">
        <li class="nav-item">
            <router-link :to="'/statistic/buyout/country'" class="nav-link" exact><i class="fa fa-globe"></i> {{ $t('pages.by_country') }}</router-link>
        </li>
        <li class="nav-item">
            <router-link :to="'/statistic/buyout/offers'" class="nav-link" exact><i class="fa fa-briefcase"></i> {{ $t('pages.by_offers') }}</router-link>
        </li>
        <li class="nav-item">
            <router-link :to="'/statistic/buyout/couriers'" class="nav-link" exact><i class="fa fa-calendar-o"></i> {{ $t('pages.by_couriers') }}</router-link>
        </li>
        <li class="nav-item">
            <router-link :to="'/statistic/buyout/weeks'" class="nav-link" exact><i class="fa fa-calendar"></i> {{ $t('pages.by_weeks') }}</router-link>
        </li>
        <li class="nav-item">
            <router-link :to="'/statistic/buyout/days'" class="nav-link" exact><i class="fa fa-calendar-check-o"></i> {{ $t('pages.by_days') }}</router-link>
        </li>
      <li class="nav-item">
        <router-link :to="'/statistic/buyout/month'" class="nav-link" exact><i class="fa fa-calendar-check-o"></i> {{ $t('pages.by_month') }}</router-link>
      </li>
    </ul>
</template>

<script>
  export default {
    name: 'BuyoutTabs'
  }
</script>



// WEBPACK FOOTER //
// BuyoutTabs.vue?2f606a18